<template>
	<div class="laundry">
		<v-layout row wrap mb-3>
			<v-flex md10 pl-1 class="text-xs-left">
				<div class="inline-filter-list">
					<filter-list v-bind:value="filterValue" v-on:selected-filter="selectedFilter"
					/>
				</div>
			</v-flex>
			<v-flex md2 class="text-xs-right">
				<button-create :text="'Prenda'" :href="href"></button-create>
			</v-flex>
		</v-layout>
		<table-run
			v-bind:columns="columns"
			v-bind:rows="rows"
			v-bind:include-delete="true"
			v-bind:include-export-to-excel="true"
			v-bind:include-options="true"
			v-bind:include-switch="true"
			v-bind:include-settings="true"
			v-bind:include-delete-single="true"
			v-bind:switch-value="'flagActive'"
			v-on:on-sortable-event="columnSortableEvent"
			v-on:on-search-event="searchByColumn"
			v-on:on-change-state="changeState"
			v-on:on-delete-event="deleteRow"
			v-on:on-delete-selected="deleteRows"
			v-on:on-export-selected="exportToExcel"
			v-on:go-to-edit-page="goToEdit">
			<template slot="rows" scope="props">
				<td class="image-column">
					<div class="laundry-image">
						<img v-bind:src="props.row.urlImage" v-bind:alt="props.row.name"
						  width="28" height="26" />
					</div>
				</td>
				<td>{{ props.row.name }}</td>
				<td>{{ props.row.price | round }}</td>
			</template>
		</table-run>
		<v-layout row wrap justify-end mt-3 v-show="totalPages">
			<v-pagination
				:length="totalPages"
				:total-visible="pagesVisible"
				v-model="page"
				v-on:input="changePage">
			</v-pagination>
		</v-layout>
	</div>
</template>

<script>
import TableRun from 'table-run';
import { round } from '@/shared/filters';
import mixin from '@/shared/mixins';
import ButtonCreate from '@/components/shared/ButtonCreate';
import FilterList from '@/components/shared/FilterList';

function created() {
	this.loadData();
}

async function changePage(value) {
	this.page = value;
	this.loadData();
}

async function changeState({ id }) {
	const modelRow = this.rows.filter(row => row.id === id)[0];
	await this.$http.patch(`${process.env.PRODUCTS_URL}/p/products/${id}/flag-active`, { flagActive: modelRow.flagActive });
	this.loadData();
}

function columnSortableEvent({ id }) {
	const self = this;
	const newColumn = self.columns.filter(column => column.id === id);
	newColumn[0].isSortable = newColumn[0].isSortable.down ?
		{ down: false, up: true } : { down: true, up: false };
	self.columns = self.columns.map((columnSingle) => {
		const newColumnSingle = Object.assign({}, columnSingle);
		if (columnSingle.isSortable) {
			if (columnSingle.id !== newColumn[0].id) {
				newColumnSingle.isSortable = { down: true, up: false };
			}
		}
		return newColumnSingle;
	});
	this.sortField = newColumn[0].code;
	this.sortDirection = newColumn[0].isSortable.up ? 'asc' : 'desc';
	this.loadData();
}

async function deleteRow({ id }) {
	await this.$http.delete(`${process.env.PRODUCTS_URL}/p/products/${id}`);
	this.showNotification('La prenda se eliminó correctamente', 'success');
	this.loadData();
}

async function deleteRows(rows) {
	const ids = rows.map(row => row.id);
	const model = {
		ids,
	};
	await this.$http.delete(`${process.env.PRODUCTS_URL}/p/products`, { body: model });
	this.showNotification('Las prendas se eliminaron correctamente', 'success');
	this.loadData();
}

function exportToExcel(rows) {
	const fieldNames = this.columns.map(column => column.name);
	const columns = this.columns.map(column => column.code);
	this.exportToCSV(fieldNames, columns, rows, 'Listado de prendas');
}

function goToEdit({ id }) {
	const editHref = { name: 'config-laundry', params: { laundryId: id } };
	this.$router.push(editHref);
}

async function loadData() {
	const parameters = {
		page: this.page,
		limit: this.limit,
	};
	if (this.flagActive || this.flagActive === 0) {
		parameters.flagActive = this.flagActive;
	}
	if (this.search) {
		parameters.search = this.search;
	}
	if (this.sortField) {
		parameters.sortField = this.sortField;
	}
	if (this.sortDirection) {
		parameters.sortDirection = this.sortDirection;
	}
	const response = await this.$http.get(`${process.env.PRODUCTS_URL}/p/products/laundry`, { params: parameters });
	this.totalPages = Number(response.headers.get('x-last-page'));
	this.rows = response.data;
	this.loading = false;
}

function pagesVisible() {
	return this.totalPages < 5 ? this.totalPages : 5;
}

function searchByColumn(search) {
	this.search = search;
	this.page = 1;
	this.loadData();
}

function selectedFilter(filter) {
	this.filterValue = filter.id;
	if (filter.id === 2) {
		this.flagActive = 1;
		this.loading = true;
		this.page = 1;
		this.loadData();
	} else if (filter.id === 3) {
		this.flagActive = 0;
		this.loading = true;
		this.page = 1;
		this.loadData();
	} else {
		this.flagActive = null;
		this.loading = true;
		this.page = 1;
		this.loadData();
	}
}

export default {
	components: {
		ButtonCreate,
		FilterList,
		TableRun,
	},
	computed: {
		pagesVisible,
	},
	created,
	data() {
		return {
			columns: [
				{ id: 1, name: 'Imagen', code: 'urlImage' },
				{ id: 2, name: 'Nombre', code: 'name', isSortable: { down: true, up: false } },
				{ id: 3, name: 'Precio del Lavado', code: 'price', isSortable: { down: true, up: false } },
			],
			filterValue: 1,
			flagActive: null,
			href: { name: 'form-laundry' },
			limit: 10,
			loading: false,
			page: 1,
			rows: [],
			totalPages: 5,
			search: null,
			sortDirection: null,
			sortField: null,
		};
	},
	filters: {
		round,
	},
	methods: {
		changePage,
		changeState,
		columnSortableEvent,
		deleteRow,
		deleteRows,
		exportToExcel,
		goToEdit,
		loadData,
		searchByColumn,
		selectedFilter,
	},
	mixins: mixin,
	name: 'laundry',
};
</script>

<style lang="scss" scoped>
.image-column {
	height: 52px !important;
	padding: 5px 20px 5px 0px !important;
	width: 73px;
}

.laundry-image {
	background-color: white;
	border: solid 1px map-get($colors, bg-subtitle);
	height: 100%;
	padding: 13px 20px;

	img {
		vertical-align: middle;
	}
}
</style>




// WEBPACK FOOTER //
// List.vue?2dd9c231